import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import messageWithdrawalJS from './messageWithdrawal'; 
import { fileReader, compressImage } from '../../components/common/file' 
import UUID from 'uuidjs'; 
var Queue = require('./queue.js');
var messageQueue = new Queue();
var csrJS = {
mixins: [messageWithdrawalJS],
directives: {
TransferDom
},
components: {},
data() {
return {

user: {
accountId: '', // 客户id
name: '', // 用户名
img: '' 
},
customerToGoods: {}, // 当前询问商品信息
messageExample: {

messageContent: '', // 消息内容
messageDuration: 0, // 时长(针对语音、视频)  默认 0
messageType: 0 
},
autosize: true, // 是否根据内容自动设置高度 （文本框）

currentPage: 1, // 当前页码
pageSize: 10, // 每页条数
isLast: false, // 是否加载更多
isListMonitor: true, // 列表监听动作 true 滑到最底部   false 滑到当前
isPrevious: true, // 判断消息加载动作  true  (首次加载、收/发消息) ； false  (加载更多)
msgListHeight: 0, // 会话列表高度

csrPhoto: './static/images/csr_photo.png', // 客服头像
/** 消息列表
* content                                    内容
* date                                           时间
* self                                             (ture 代表自己发的消息)
* messageType                        消息类型(0:文本，1:语音，2:图片，3:视频，4:商品)
* istemporary                           (1 代表临时消息)
* customerToGoods              商品信息
* csrName                                  客服名称
* isResd                                       是否已读
*/
msgList: [],
lastPage: false, //列表滚动节流开关
originalHeight: 0, // 屏幕原始高度
judgeDeviceType: {}, // 设备类型
popConfirmMenus: false, // 是否弹出确认菜单 开关
confirmMenusHeader: '<span style="color:#666;font-size:12px;">是否撤回该条消息？</span>', // 确认菜单头部

confirmMenus: [
{
label: '确定',
type: 6
}
],
};
},
computed: {
userInfo() {
return this.$store.state.userInfo;
},
isHighlight() {
let haveValue;
if (this.messageExample.messageContent) {
haveValue = true;
} else {
haveValue = false;
}
return haveValue;
}
},
watch: {

userInfo: {
handler(userInfo) {
if (this.$store.state.pcCsrShow) {
if (userInfo && userInfo.accountId) {

this.user.accountId = userInfo.accountId;
this.user.img = userInfo.poster || '';
this.user.name = userInfo.displayName || '';



this.loadMsgList(1); 


if (sessionStorage.getItem('customerToGoods')) {
this.customerToGoods = JSON.parse(sessionStorage.getItem('customerToGoods'));
} else {
this.customerToGoods = {};
}
}
}
},
deep: true
},

msgList() {

if (this.isPrevious) {

let that = this;
this.$nextTick(() => {
setTimeout(() => {
let msg = document.getElementById('msgList'); 




that.msgListHeight = msg.scrollHeight;
msg.scrollTop = msg.scrollHeight; 

}, 300);
});
} else {

let that = this;
this.$nextTick(() => {
setTimeout(() => {
let msg = document.getElementById('msgList'); 
msg.scrollTop = msg.scrollHeight - that.msgListHeight; 




that.msgListHeight = msg.scrollHeight;
}, 100);
});
}
}
},
methods: {

receiveMsg(obj) {

if (obj.msgType == 17) {

let csrMessage = JSON.parse(obj.body);
var sendMsg = {
req: {
recordId: csrMessage.recordId 
},
action: 'readUpdates'
};
sendMsg = JSON.stringify(sendMsg);
this.$store.state.APPPAGE.websocketsend(sendMsg);
for (let index = 0; index < this.msgList.length; index++) {
if (csrMessage.recordId) {
if (this.msgList[index].customerServiceConsultId == csrMessage.recordId) {
this.msgList[index].isResd = 1;
}
} else {
this.msgList[index].isResd = 1;
}
}
}

if (obj.msgType == 18) {
if (obj.body) {
let csrMessage = JSON.parse(obj.body);
for (let index = 0; index < this.msgList.length; index++) {
if (this.msgList[index].customerServiceConsultId == csrMessage.customerServiceConsultId) {
this.msgList[index].messageStatus = 1;
}
}
}
}

if (obj.msgType == 15) {
if (obj.body) {
this.isPrevious = true;
let csrMessage = JSON.parse(obj.body);
let date = this.getCurrentTimestamp();
var csrSpeech = {
customerServiceConsultId: csrMessage.customerServiceConsultId,
content: '',
csrName: csrMessage.csrName,
date: csrMessage.createTime,
self: false,
messageStatus: 0,
isOptionsShow: false,
messageType: csrMessage.messageType
};
if (csrSpeech.messageType == 0) {
csrSpeech.content = csrMessage.messageContent;
}
if (csrSpeech.messageType == 2) {
csrSpeech.content = sessionStorage.fileURL + csrMessage.messageContent;
var params = this.$queryUrlParams(csrMessage.messageContent);
csrSpeech.imgWidth = params && params.imgWidth || '';
csrSpeech.imgHeight = params && params.imgHeight || '';
}
if (csrSpeech.messageType == 4) {
csrSpeech.customerToGoods = [];
this.loadDetail(csrMessage.messageContent, csrSpeech, 1);
}
this.msgList.push(csrSpeech); 

var sendMsg = {
req: {
recordId: csrMessage.customerServiceConsultId 
},
action: 'appConfirm'
};
sendMsg = JSON.stringify(sendMsg);

this.$store.state.APPPAGE.websocketsend(sendMsg);
} else {

if (obj.status == 500) {
this.$vux.toast.text('发送消息失败');
return;
}
if (obj.status == 200) {
if (obj.msg) {
var mark = 'mark';
let messageIndex = messageQueue.Inquire(mark, obj.msg);
let messageItem = {};
if (messageIndex == 0) {
messageItem = messageQueue.dequeue();
} else if (messageIndex != -1) {
let returnResult = messageQueue.culling(messageIndex);
messageItem = returnResult[0];
}
if (messageItem) {
if (messageItem.messageType == 0) {
messageItem.content = messageItem.content;
}
if (messageItem.messageType == 2) {
var params = this.$queryUrlParams(messageItem.content);
messageItem.imgWidth = params && params.imgWidth || '';
messageItem.imgHeight = params && params.imgHeight || '';
}
messageItem.customerServiceConsultId = obj.id;
messageItem.messageStatus = 0;
messageItem.isOptionsShow = false;
this.msgList.push(messageItem);

}
}
}
}
}
},
/**
* 加载当前客服会话消息
*  type: 1获取最新，2上拉获取更多
*/
loadMsgList(type) {
if (type == 1) {
this.currentPage = 1;
} else {
this.currentPage++;
}
let that = this;
that.$vux.loading.show();
setTimeout(() => {
that.$vux.loading.hide();
}, 1000);
let accountId = that.user.accountId || '';
if (!accountId) {
that.updateUserInfo();
return;
}
that.$axios
.get('/api/v1.0/lonbonShop/getConsultMsg', {
params: {
accountId: accountId, // 用户ID
currentPage: that.currentPage,
pageSize: that.pageSize
}
})
.then(function (res) {
if (res.status == 200) {
that.msgIsRed();
that.emptyUnreadMessages();

var dataList = res.body.list.reverse().map((item, index) => {

if (item.senderType == 0) {

item.self = true;
}
item.isOptionsShow = false;
item.date = item.createTime;

if (item.messageType == 0) {
item.content = item.messageContent;
item.date = item.createTime;
}

if (item.messageType == 2) {
item.content = sessionStorage.fileURL + item.messageContent;
var params = that.$queryUrlParams(item.messageContent);
item.imgWidth = params && params.imgWidth || '';
item.imgHeight = params && params.imgHeight || '';
}

if (item.messageType == 4) {
item.customerToGoods = [];
if (type == 1) {

that.loadDetail(item.messageContent, item, 1);
} else {

that.loadDetail(item.messageContent, item);
}
}
return item;
});

if (type == 1) {
that.msgList = dataList;
if (that.customerToGoods.goodsId) {
let date = that.getCurrentTimestamp();

var mySpeech = {
content: '',
customerToGoods: [], // 商品信息
date: date,
self: true,
messageType: 4, // 4 商品消息
istemporary: 1 
};
mySpeech.customerToGoods.push(that.customerToGoods);
that.msgList.push(mySpeech);
}
} else {
dataList.reverse().map(item => {
that.msgList.unshift(item);
});
}
that.$store.state.APPPAGE.whetherInitWebSocket();

} else {
that.lastPage = true;
}
that.$vux.loading.hide();
})
.catch(function () {
that.$vux.loading.hide();
});
},

loadDetail(goodsId_, item_, slide_, position_) {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/goodsDetails', {
params: {
goodsId: goodsId_
}
})
.then(function (response) {
if (response.status == 200) {
let one = response.body;
let photos = [];
one.photo.forEach(item => {
var file = {
id: item.goodsPhotoId,
url: sessionStorage.fileURL + item.photo,
file: null,
status: 1,
remotePath: item.photo
};
if (item.photoType == 0) {
photos.push(file);
}
});
one.photos = photos;
one.poster = one.photos[0].remotePath;
var goods = one;
item_.customerToGoods.push(goods);
if (slide_ == 1) {
that.$nextTick(() => {
let msg = document.getElementById('msgList'); 
that.msgListHeight = msg.scrollHeight;
msg.scrollTop = msg.scrollHeight; 
});
}
}
});
},

sendGoodsID() {
this.isPrevious = true;
let mark = UUID.generate();
let accountId = this.user.accountId || '';
if (!accountId) {
this.updateUserInfo();
this.$vux.toast.text('发送消息失败，请稍候重试');
return;
}
var sendMsg = {
req: {
mark: mark,
consultMsg: {
accountId: accountId,
messageContent: this.customerToGoods.goodsId,
messageType: 4,
senderType: 0,
name: this.user.name, // 用户昵称
headImage: this.user.img 
}
},
action: 'consultMsg'
};
sendMsg = JSON.stringify(sendMsg);
console.log('发送商品' + sendMsg);
this.$store.state.APPPAGE.websocketsend(sendMsg, 1);

let date = this.getCurrentTimestamp();

var mySpeech = {
mark: mark,
content: '',
customerToGoods: [], // 商品信息
date: date,
self: true,
isResd: 0,
messageType: 4 
};
mySpeech.customerToGoods.push(this.customerToGoods);
messageQueue.enqueue(mySpeech);

for (let index = 0; index < this.msgList.length; index++) {
if (this.msgList[index].istemporary == 1) {
this.msgList.splice(index, 1);
index--;
}
}
},

saveConsultMsg() {
let accountId = this.user.accountId || '';
if (!accountId) {
this.updateUserInfo();
this.$vux.toast.text('发送消息失败，请稍候重试');
return;
}
this.messageExample.messageContent = this.messageExample.messageContent.replace(/\n/g, '<br/>');
this.messageExample.messageContent = this.messageExample.messageContent.replace(/\s/g, '&nbsp;');
this.isPrevious = true;
if (this.messageExample.messageContent && this.messageExample.messageContent.trim()) {
let mark = UUID.generate();
var sendMsg = {
req: {
mark: mark,
consultMsg: {
accountId: accountId, // 用户Id
messageContent: this.messageExample.messageContent,
messageType: 0,
senderType: 0,
name: this.user.name, // 用户昵称
headImage: this.user.img 
}
},
action: 'consultMsg'
};
sendMsg = JSON.stringify(sendMsg);

this.$store.state.APPPAGE.websocketsend(sendMsg, 1);
let date = this.getCurrentTimestamp();
var mySpeech = {
mark: mark,
content: this.messageExample.messageContent,
date: date,
self: true,
isResd: 0,
messageType: 0
};
messageQueue.enqueue(mySpeech);
console.log('当前未发送成功的消息队列数据' + JSON.stringify(messageQueue.returnArray()));
this.messageExample.messageContent = ''; 
this.autosize = false;
let that = this;
this.$nextTick(() => {
that.autosize = true;
});
} else {
this.$vux.toast.text('不能发送空白消息哦');
}
},

timestampToTime(value) {
if (value && value != '0') {
if ((value + '').length > 10) {
value = value / 1000;
}
return this.$moment(value * 1000).format('YYYY-MM-DD HH:mm');
}
},

getCurrentTimestamp() {
let currentTimestamp = new Date().getTime();
currentTimestamp = currentTimestamp.toString();
currentTimestamp = currentTimestamp.substr(0, currentTimestamp.length - 3);
currentTimestamp = parseInt(currentTimestamp);
return currentTimestamp;
},

focusHandle() {
var $inputs = $('textarea');
clearInterval(this.textareaFocusInterval);
this.showDropdown = false;
this.textareaFocusInterval = null;
this.textareaFocusInterval = setInterval(() => {
$inputs[0].scrollIntoView(true);
$inputs[0].scrollIntoViewIfNeeded();
}, 100);
},

blurHandle() {
setTimeout(() => {
clearInterval(this.textareaFocusInterval);
this.textareaFocusInterval = null;
}, 1);
},

clickHandle() {
$('#messageInput textarea').focus();
this.showDropdown = false;
},
/* 搜索框相关函数 end*/

chooseFile() {

this.$refs.sendImage.dispatchEvent(new MouseEvent('click'));
},

async getFileName(e) {
this.isPrevious = true;
let that = this;
var files = e.target.files;
if (files.length < 10) {
for (var i = 0; i < files.length; i++) {
var file = files[i];

var one = await fileReader(file);
var imgScale = one.width / one.height;
if (one.width >= 128 || one.height >= 160) {
if (imgScale < 0.8) {
one.imgHeight = 160;
one.imgWidth = 160 * imgScale;
} else {
one.imgWidth = 128;
one.imgHeight = 128 / imgScale;
}
} else {
one.imgWidth = one.width;
one.imgHeight = one.height;
}
one.blob = await compressImage(one.file, {
size: 200,
width: one.imgWidth * 6,
height: one.imgHeight * 6,
});


that.ajaxUpload(one);
}
} else {
this.$vux.toast.text('你最多只能选择9张图片');
}


this.messageExample.messageType = 0;
},
ajaxUpload(one) {
let that = this;
that.$vux.loading.show();
let formData = new FormData();
formData.append('file', one.blob, one.file.name);
that.$axios
.post('/api/v1.0/familyApp/uploadFilePath', formData, {
setting: {
timeout: 30000
}
})
.then(function (response) {
if (response.status == 200) {
one.remotePath = response.body;
that.$vux.loading.hide();
let mark = UUID.generate();
if (!that.user.accountId) {
that.updateUserInfo();
that.$vux.toast.text('发送消息失败，请稍候重试');
return;
}
var sendMsg = {
req: {
mark: mark,
consultMsg: {
accountId: that.user.accountId, // 用户Id
messageContent: one.remotePath + '?imgWidth=' + one.imgWidth + '&imgHeight=' + one.imgHeight, // 消息内容
messageType: 2, // 消息类型(0:文本,1:语音,2:图片,3:视频)
senderType: 0, // 发送人类型(0:用户,1客服)
name: that.user.name, // 用户昵称
headImage: that.user.img 
} //消息对象
},
action: 'consultMsg'
};
sendMsg = JSON.stringify(sendMsg);

that.$store.state.APPPAGE.websocketsend(sendMsg, 1);
let date = that.getCurrentTimestamp();
var mySpeech = {
mark: mark,
content: sessionStorage.fileURL + one.remotePath + '?imgWidth=' + one.imgWidth + '&imgHeight=' + one.imgHeight,
date: date,
self: true,
isResd: 0,
messageType: 2
};

messageQueue.enqueue(mySpeech);
console.log('当前未发送成功的消息队列数据' + JSON.stringify(messageQueue.returnArray()));
$('#push-file').val('');
} else {
that.$vux.loading.hide();
}
})
.catch(err => {
console.log(err);
that.$vux.loading.hide();
});
},

getImgWidthHeight(fileUrl) {
return new Promise((resolve, reject) => {
let img = new Image();
let res = {};

img.onload = function () {
res = {
width: this.width,
height: this.height
};
resolve(res);
};
img.src = fileUrl;
});
},

msgListTouchMonitor() {
let that = this;
$('#msgList').on('click', function () {

$('#messageInput')
.find('textarea')
.blur();
for (let index = 0; index < that.msgList.length; index++) {
that.msgList[index].isOptionsShow = false;
}
that.showDropdown = false;
});
},

toDetail(item) {
this.$router.push('/goodsDetail?backPath=' + this.$route.path + '&goodsId=' + item.goodsId);
},

logCurrentCsr() {
let that = this;
let accountId = that.user.accountId || '';
if (!accountId) {
that.updateUserInfo();
return;
}
that.$axios
.get('/api/v1.0/lonbonShop/getCsr', {
params: {
accountId: accountId
}
})
.then(function (response) {
console.log('客服连接：' + response.msg);
});
},

upslideLoading() {
let that = this;
var throttleSwitch = true;
$('#msgList').scroll(function () {

let msgListDoc = this;
setTimeout(function () {

var nDivHight = $(msgListDoc).height();
var nScrollHight = $(msgListDoc)[0].scrollHeight;
var nScrollTop = $(msgListDoc)[0].scrollTop;
if (nScrollTop <= 0) {
if (!that.isLast) {
if (throttleSwitch) {
throttleSwitch = false;
setTimeout(function () {
console.log('滚动条到顶部了');
that.isPrevious = false; 
that.loadMsgList(2);
throttleSwitch = true;
}, 300);
}
}
}
}, 300);
});
},

msgIsRed() {
let that = this;
let accountId = that.user.accountId || '';
if (!accountId) {
that.updateUserInfo();
return;
}
var data = {
accountId: accountId 
};
that.$axios.post('/api/v1.0/lonbonShop/pushIsResd', that.qs.stringify(data)).then(function (res) {
if (res.status == 200) { }
});
},

emptyUnreadMessages() {
var userUnreadInfo = [];
if (localStorage.getItem('unreadInfo')) {
userUnreadInfo = JSON.parse(localStorage.getItem('unreadInfo'));
this.$store.state.APPPAGE.arrayDeduplication(userUnreadInfo); 
}
if (userUnreadInfo.length > 0) {
for (let index = 0; index < userUnreadInfo.length; index++) {
if (userUnreadInfo[index].accountId && this.user && (userUnreadInfo[index].accountId == this.user.accountId)) {
userUnreadInfo[index].unreadMessageNum = 0;
this.$store.state.unreadMessageNum = 0;
}
}
}
localStorage.setItem('unreadInfo', JSON.stringify(userUnreadInfo));
},

updateUserInfo() {
if (!this.$isPc()) {
if (this.$isWeixin()) {
this.$store.state.APPPAGE.getUserInfo(10);
} else {
this.$store.state.APPPAGE.getUserInfo(1);
}
}
}
},
mounted() {
this.$store.state.CustomerPage = this;
}
};
export default csrJS = csrJS



// WEBPACK FOOTER //
// ./src/pcComponents/customerService/csr.js